// jQuery(function () {
//   jQuery(
//     "#shopify-section-template--17665222836404__image_with_text_overlay_iYR6yF .content-over-media"
//   ).parallaxBlock({
//     parallaxOffset: 0,
//     fallbackClass: "fallback-class",
//   });

//   jQuery(
//     "#shopify-section-template--17665222836404__image_with_text_overlay_8db4xH .content-over-media"
//   ).parallaxBlock({
//     parallaxOffset: 0,
//     fallbackClass: "fallback-class",
//   });

//   jQuery(
//     "#shopify-section-template--17665222836404__image_with_text_overlay_9bGAPB .content-over-media"
//   ).parallaxBlock({
//     parallaxOffset: 0,
//     fallbackClass: "fallback-class",
//   });
// });

// (function ($) {
//   "use strict";

//   var ParallaxController = (function () {
//     var $win = $(window);
//     var items = [];
//     var winProps = {
//       width: 0,
//       height: 0,
//       scrollTop: 0,
//     };

//     return {
//       init: function () {
//         $win.on("load resize orientationchange", this.resizeHandler.bind(this));
//         $win.on("scroll", this.scrollHandler.bind(this));
//         this.resizeHandler();
//       },

//       resizeHandler: function () {
//         winProps.width = $win.width();
//         winProps.height = $win.height();

//         $.each(items, this.calculateSize.bind(this));
//       },

//       scrollHandler: function () {
//         winProps.scrollTop = $win.scrollTop();

//         $.each(items, function (i) {
//           var item = items[i];

//           // ✅ Section is in viewport and near top (adjust margin as needed)
//           var sectionTopVisible =
//             winProps.scrollTop >= item.topOffset - 1 &&
//             winProps.scrollTop <= item.topOffset + item.height;

//           if (sectionTopVisible) {
//             item.$el.addClass("parallax-started"); // optional for debugging
//             ParallaxController.calculateScroll(i);
//           } else {
//             item.$el.removeClass("parallax-started");
//           }
//         });
//       },

//       calculateSize: function (i) {
//         var item = items[i];
//         var bgWidth;
//         var bgHeight;

//         item.height = item.$el.outerHeight();
//         item.width = item.$el.outerWidth();
//         item.topOffset = item.$el.offset().top;
//         item.bgHeight = winProps.height + item.options.parallaxOffset;
//         item.itemRatio =
//           winProps.width / (winProps.height + item.options.parallaxOffset);

//         if (item.imageRatio <= item.itemRatio) {
//           bgWidth = winProps.width;
//           bgHeight = bgWidth / item.imageRatio;
//           bgWidth += "px ";
//           bgHeight += "px ";
//         } else {
//           bgWidth = "auto ";
//           bgHeight = winProps.height + item.options.parallaxOffset;
//           bgHeight += "px ";
//         }

//         item.$el.css({
//           backgroundSize: bgWidth + bgHeight,
//         });

//         // Recalculate scroll position if in view
//         var scrollTop = $win.scrollTop();
//         if (
//           scrollTop >= item.topOffset - 1 &&
//           scrollTop <= item.topOffset + item.height
//         ) {
//           this.calculateScroll(i);
//         }
//       },

//       calculateScroll: function (i) {
//         var item = items[i];
//         var curPos;
//         var offsetPercentage = Math.max(
//           0,
//           Math.min(
//             (winProps.scrollTop + winProps.height - item.topOffset) /
//               (winProps.height + item.height),
//             1
//           )
//         ).toFixed(4);

//         if (item.imageRatio <= item.itemRatio) {
//           curPos =
//             "50% " +
//             (-parseFloat(offsetPercentage) * item.options.parallaxOffset -
//               (item.bgHeight - winProps.height) / 2) +
//             "px";
//         } else {
//           curPos =
//             "50% " +
//             -parseFloat(offsetPercentage) * item.options.parallaxOffset +
//             "px";
//         }

//         item.$el.css({ backgroundPosition: curPos });
//       },

//       add: function (el, options) {
//         var $el = $(el);
//         var $image = $el.find(options.image);

//         function setBackgroundImage() {
//           var imgSrc = $image[0].currentSrc || $image.attr("src");
//           var imageRatio =
//             $image[0].naturalWidth / $image[0].naturalHeight || 1;

//           if (imgSrc) {
//             $el.css({
//               backgroundImage: "url(" + imgSrc + ")",
//             });

//             $image.remove();

//             var newIndex = items.push({
//               $el: $el,
//               options: options,
//               imageRatio: imageRatio,
//             });

//             ParallaxController.calculateSize(newIndex - 1);
//           }
//         }

//         if ($image[0].complete) {
//           setBackgroundImage();
//         } else {
//           $image.on("load", setBackgroundImage);
//         }

//         options.parallaxOffset = Math.abs(options.parallaxOffset);
//       },
//     };
//   })();

//   ParallaxController.init();

//   $.fn.parallaxBlock = function (options) {
//     options = $.extend(
//       {
//         parallaxOffset: 100,
//         fallbackClass: "fallback-class",
//         image: "img",
//       },
//       options
//     );

//     return this.each(function () {
//       if (this.added) return;
//       this.added = true;
//       ParallaxController.add(this, options);
//     });
//   };
// })(jQuery);

// Logo change according to section
jQuery(document).ready(function () {
  var sectionIds = [
    "#shopify-section-template--25178706673946__slideshow",
    // "#shopify-section-template--17665222836404__image_with_text_overlay_xzVBTb",
    "#shopify-section-template--333",
  ];

  function checkLogoClass() {
    var scrollTop = jQuery(window).scrollTop();
    var windowHeight = jQuery(window).height();
    var logoClassAdded = false;
    var buffer = 50;

    jQuery.each(sectionIds, function (index, id) {
      var $section = jQuery(id);

      if ($section.length) {
        var sectionTop = $section.offset().top;
        var sectionBottom = sectionTop + $section.outerHeight();

        if (
          scrollTop + buffer >= sectionTop &&
          scrollTop + buffer <= sectionBottom
        ) {
          logoClassAdded = true;
          return false;
        }
      }
    });

    jQuery(".header__logo").toggleClass("logo-light", logoClassAdded);
  }

  jQuery(window).on("scroll", checkLogoClass);
  checkLogoClass();
});

// New in section add next,prev buttons
$(function () {
  var $section = $("#shopify-section-template--25178706673946__multi_column_Rp8x87");
  var $multiColumn = $section.find(".multi-column");

  // Wrap .multi-column
  $multiColumn.wrap('<div class="multi-column-wrapper" style="position: relative;"></div>');
  var $wrapper = $section.find(".multi-column-wrapper");

  // Add buttons
  var $prevBtn = $('<button class="scroll-prev">←</button>');
  var $nextBtn = $('<button class="scroll-next">→</button>');
  $wrapper.prepend($prevBtn);
  $wrapper.append($nextBtn);

  // Calculate exact scroll amount (1 item + gap)
  var $firstItem = $multiColumn.find(".multi-column__item").first();
  var scrollAmount = $firstItem.outerWidth(true); // includes margin/gap

  // Add pagination container
  var $pagination = $('<div class="slider-pagination"></div>');
  $wrapper.append($pagination);

  // Create pagination dots
  var totalItems = $multiColumn.find(".multi-column__item").length;
  for (var i = 0; i < totalItems; i++) {
    $pagination.append('<span class="dot" data-index="' + i + '"></span>');
  }

  // Update active dot
  function updatePagination() {
    var scrollLeft = $multiColumn.scrollLeft();
    var currentIndex = Math.round(scrollLeft / scrollAmount);
    $pagination.find(".dot").removeClass("active");
    $pagination.find(".dot").eq(currentIndex).addClass("active");
  }

  // Handle dot click (optional but nice UX)
  $pagination.on("click", ".dot", function () {
    var index = $(this).data("index");
    $multiColumn.animate({ scrollLeft: index * scrollAmount }, 300, updatePagination);
  });

  // Scroll buttons
  $prevBtn.on("click", function () {
    $multiColumn.animate(
      { scrollLeft: $multiColumn.scrollLeft() - scrollAmount },
      300,
      updatePagination
    );
  });

  $nextBtn.on("click", function () {
    $multiColumn.animate(
      { scrollLeft: $multiColumn.scrollLeft() + scrollAmount },
      300,
      updatePagination
    );
  });

  // Update on manual scroll too
  $multiColumn.on("scroll", function () {
    updatePagination();
  });

  // Initialize active dot
  updatePagination();
});


